import Vue from 'vue'
import Router from 'vue-router'

import beranda from './beranda'
import info from './info'

import NotFoundPage from '../views/NotFoundPage.vue'
// import Help from '../views/statics/Help.vue'

const Container = () =>
  import(/* webpackChunkName: "umum" */ '../views/Container.vue')

Vue.use(Router)

export function createRouter(base) {
  return new Router({
    mode: 'history',
    base: base,
    linkActiveClass: 'open active',
    scrollBehavior: () => ({
      x: 0,
      y: 0
    }),
    routes: [
      {
        path: '/',
        redirect: 'index',
        name: 'root',
        component: Container,
        children: [
          ...beranda,
          ...info
        ]
      },
      {
        path: '*',
        name: 'error404',
        component: NotFoundPage
      },
    ]
  })
}
